import { Multiselect, Select } from 'AWS-UI-Components-React';
import React from 'react';
import { Asterisk } from './asterisk';

export class MarketplaceSelection extends React.Component {
  getSelected(selectedMarketplaceIds) {
    const { options } = this.props;
    if(this.props.multiselect) {
      return selectedMarketplaceIds && selectedMarketplaceIds.length
             ? selectedMarketplaceIds
               .split(',')
               .sort()
               .map((id) => options.find((m) => m.id === id))
             : null;
    } else {
      return selectedMarketplaceIds && selectedMarketplaceIds.split(',').length === 1
             ? selectedMarketplaceIds.split(',')[0] : '';
    }
  }

  render() {
    return (
      <div>
        <b> {this.props.text} </b>
        <Asterisk required={this.props.required}/>
        { this.props.multiselect && (
          <Multiselect
            options={ this.props.options }
            filteringType="auto"
            placeholder={ this.props.text }
            onChange={ this.props.onChange }
            checkboxes={ true }
            selectedOptions={ this.getSelected(this.props.selected) }
            data-cy={ this.props['data-cy'] }
          />)
        }
        {!this.props.multiselect && (
          <Select
            options={this.props.options}
            onChange={this.props.onChange}
            placeholder={ this.props.text }
            filteringType={'auto'}
            selectedId={this.getSelected(this.props.selected)}
            keepOpen={false}
            data-cy={this.props['data-cy']}
          />
        )}
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'marketplace-selection'
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/marketplace_selection.jsx